<div [ngSwitch]="signupPage">
  <div *ngSwitchCase="'signup'">
    <form autocomplete="off" class="p-fluid text-sm" [formGroup]="createAccountForm" (ngSubmit)="createAccount()">
      <div class="field mb-3">
        <label>{{ 'AUTH.USERNAME' | translate }}</label>
        <input formControlName="username" type="text" pInputText />
        <div
          *ngIf="createAccountForm.invalid && (createAccountForm.get('username').dirty || createAccountForm.get('username').touched)"
          class="error-box"
        >
          <div *ngIf="createAccountForm.get('username').errors?.['required']">
            {{ 'AUTH.CREATE_ACCOUNT.USERNAME_REQUIRED' | translate }}
          </div>
        </div>
      </div>
      <div class="field mb-3">
        <label>{{ 'AUTH.EMAIL' | translate }}</label>
        <input formControlName="email" type="email" pInputText />
        <div
          *ngIf="createAccountForm.invalid && (createAccountForm.get('email').dirty || createAccountForm.get('email').touched)"
          class="error-box"
        >
          <div *ngIf="createAccountForm.get('email').errors?.['required']">{{ 'AUTH.CREATE_ACCOUNT.EMAIL_REQUIRED' | translate }}</div>
        </div>
      </div>
      <div class="field mb-4">
        <label>{{ 'AUTH.PASSWORD' | translate }}</label>
        <p-password
          id="password"
          formControlName="password"
          autocomplete="one-time-code"
          [toggleMask]="true"
          [feedback]="false"
        ></p-password>
        <div
          *ngIf="!createAccountForm.get('password').dirty && !createAccountForm.get('password').touched"
          class="mt-1 text-xs text-black-alpha-60"
        >
          {{ 'AUTH.CREATE_ACCOUNT.PASSWORD_MIN_LENGTH' | translate }}
        </div>
        <div
          *ngIf="createAccountForm.invalid && (createAccountForm.get('password').dirty || createAccountForm.get('password').touched)"
          class="error-box mt-1"
        >
          <div *ngIf="createAccountForm.get('password').errors?.['required'] || createAccountForm.get('password').errors?.['minlength']">
            {{ 'AUTH.CREATE_ACCOUNT.PASSWORD_MIN_LENGTH' | translate }}
          </div>

          <div *ngIf="createAccountForm.errors?.['notCorrect']">{{ createAccountForm.errors?.['notCorrect'] | translate }}</div>
        </div>
      </div>
      <button pButton pRipple type="submit" [label]="'AUTH.CREATE_ACCOUNT.BUTTON' | translate" class="p-button-warning"></button>
      <p class="text-xs mt-2">
        {{ 'AUTH.CREATE_ACCOUNT.CREATE_ACCOUNT_AGREEMENT' | translate }} {{ 'AUTH.TERMS.AGREEMENT' | translate }}
        <a [href]="TERMS" target="_blank" class="underline">{{ 'AUTH.TERMS.LINK' | translate }}</a>
        {{ 'AUTH.TERMS.OF_PLATFORM' | translate }} {{ 'AUTH.CREATE_ACCOUNT.CONSENT_TO_MARKETING' | translate }}
      </p>
    </form>
    <div class="flex flex-column align-items-center justify-content-center">
      <fp-google-login-button [signup]="true" [lang]="translate.getCurrentLang()"></fp-google-login-button>
      <fp-linkedin-login-button [signup]="true" [lang]="translate.getCurrentLang()"></fp-linkedin-login-button>
    </div>
    <footer class="yellow-back text-sm font-bold text-center -mx-5 -mb-6 mt-4 p-3">
      <p class="mb-0">
        {{ 'AUTH.CREATE_ACCOUNT.HAVE_ACCOUNT' | translate }}
        <a [href]="PUBLICLOGIN" class="underlined" style="cursor: pointer">{{ 'AUTH.BUTTON' | translate }}</a>
      </p>
    </footer>
  </div>
  <div *ngSwitchCase="'waitingVerification'" class="text-center">
    <h2>{{ 'AUTH.CREATE_ACCOUNT.VERIFY_EMAIL' | translate }}</h2>
    <p class="text-sm mb-3">
      {{ 'AUTH.CREATE_ACCOUNT.VERIFY_EMAIL_DESCRIPTION' | translate }} <span class="font-bold">{{ userEmail }}</span
      >.
      {{ 'AUTH.CREATE_ACCOUNT.VERIFY_EMAIL_DESCRIPTION_2' | translate }}
    </p>

    <p class="text-xs">
      {{ 'AUTH.CREATE_ACCOUNT.SUPPORT_TEAM' | translate }} <a href="mailto:help@femmepalette.com">help&#64;femmepalette.com</a>
    </p>
  </div>
</div>
